"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  legend: _propTypes["default"].string.isRequired,
  onChangeCallback: _propTypes["default"].func,
  fieldValidation: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string,
    onBlur: _propTypes["default"].func,
    onChange: _propTypes["default"].func
  })
};
var defaultProps = {
  className: '',
  dataTestId: undefined,
  fieldValidation: undefined,
  onChangeCallback: function onChangeCallback() {}
};

// Required for accessibility - https://stackoverflow.com/questions/26032089/in-html-how-can-i-have-text-that-is-only-accessible-for-screen-readers-i-e-fo
var Legend = _styledComponents["default"].legend.withConfig({
  displayName: "fieldset__Legend",
  componentId: "sc-1105ods-0"
})(["position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);"]);
function Fieldset(_ref) {
  var children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    fieldValidation = _ref.fieldValidation,
    legend = _ref.legend,
    onChangeCallback = _ref.onChangeCallback;
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: "fuse-checkbox-group__fieldset ".concat(className),
    "data-testid": dataTestId,
    onChange: function onChange(e) {
      onChangeCallback(e);
      if (fieldValidation) fieldValidation.onChange(e);
    },
    onBlur: function onBlur() {
      if (fieldValidation) fieldValidation.onBlur();
    }
  }, /*#__PURE__*/_react["default"].createElement(Legend, null, legend), children);
}
Fieldset.propTypes = propTypes;
Fieldset.defaultProps = defaultProps;
var _default = exports["default"] = Fieldset;